import React from 'react'

import { Loader } from 'core-components/library/loader'
import { IModalContent } from 'core-components/library/modalDialog'
import { ICallStatus } from 'dialer/classes/models/ICallStatus'

import styles from '../windowContent/WindowContent.module.scss'
import { SimpleErrorView } from '../windowContent/windowStatus/SimpleErrorView'
import { SuccessView } from '../windowContent/windowStatus/SuccessView'

interface IProps {
  call: (phone: string) => void
}

export const CallResultModalContent = ({
  lastCallRequest,
  success,
  errorMessage,
  call,
}: ICallStatus & IProps & IModalContent) => {
  if (success) {
    return <SuccessView />
  }

  if (!success && errorMessage && lastCallRequest) {
    return <SimpleErrorView call={call} lastCallRequest={lastCallRequest} message={errorMessage} />
  }

  return (
    <div className={styles.center}>
      <Loader />
    </div>
  )
}
